<template>
  <div>
    <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Position</span>
      <div class="wf-w-1/2">
        <select v-model="position" class="wf-w-full">
          <option value="TOP">Top</option>
          <option value="BOTTOM">Bottom</option>
          <option value="FLOAT_BOTTOM">Float</option>
        </select>
      </div>
    </li>
  </div>
</template>

<script>
  import { BannerPositionClasses } from '../classes/BannerPositionClasses'
  import MenuStyleProperty from '../contracts/MenuStyleProperty'
  import EmitsPropertyEvent from '../mixins/EmitsPropertyEvent'
  export default MenuStyleProperty.extend({
    mixins: [EmitsPropertyEvent],
    watch: {
      position(value) {
        this.emitPropertyEvents(value)
      }
    },
    computed: {
      positionClasses() {
        return Object.keys(BannerPositionClasses)
      },
      position: {
        get() {
          let currentPosition = this.elementClasses(this.classes)[this.device].find(elementClass => this.positionClasses.includes(elementClass.value))
            if (! currentPosition) {
              currentPosition = {property: 'BannerPosition', value: 'FLOAT_BOTTOM', touched: false}
              this.addToArray(this.module, [currentPosition], this.classes, this.device, {}, true, this.parentModule)
            }
            return currentPosition.value
        },
        set(value) {
          let currentPosition = this.elementClasses(this.classes)[this.device].find(elementClass => this.positionClasses.includes(elementClass.value))
          value = {property: 'BannerPosition', value: value, touched: currentPosition.touched}
          this.addToArray(this.module, [value], this.classes, this.device, {}, true, this.parentModule)
        }
      }
    }
  })
</script>